import { api, useApi } from "../../../../configuration/api/apiHelper";
import { UpdateUserPortfolioItemsCommand, UserPortfolioItemViewModel } from "../../../../configuration/api/apiSchema";

// Get user portfolio items
export enum GET_USER_PORTFOLIO {
    REQUEST = "GET_USER_PORTFOLIO_REQUEST",
    SUCCESS = "GET_USER_PORTFOLIO_SUCCESS",
}

export const getUserPortfolioRequestAction = () => {
    return {
        type: GET_USER_PORTFOLIO.REQUEST
    };
};

export const getUserPortfolioSuccessAction = (userPortfolioItems: UserPortfolioItemViewModel[]) => {
    return {
        type: GET_USER_PORTFOLIO.SUCCESS,
        userPortfolioItems: userPortfolioItems
    };
};

export const getUserPortfolio = (userId?: string) => {
    return async (dispatch: any) => {
        dispatch(getUserPortfolioRequestAction());

        const response = await useApi(() =>
            api.userPortfolioItems.userPortfolioItemsList({
                userId: userId
            }));

        if (response.result) {
            dispatch(getUserPortfolioSuccessAction(response.result));
        }
        else {
            // TODO: error
            // dispatch(throwError(response.toString()));
        }
    };
};


// Update user portfolio items
export enum UPDATE_USER_PORTFOLIO {
    REQUEST = "UPDATE_USER_PORTFOLIO_REQUEST",
    SUCCESS = "UPDATE_USER_PORTFOLIO_SUCCESS",
}

export const updateUserPortfolioRequestAction = () => {
    return {
        type: UPDATE_USER_PORTFOLIO.REQUEST
    };
};

export const updateUserPortfolioSuccessAction = (userPortfolioItems: UserPortfolioItemViewModel[]) => {
    return {
        type: UPDATE_USER_PORTFOLIO.SUCCESS,
        userPortfolioItems: userPortfolioItems
    };
};

export const updateUserPortfolio = (command: UpdateUserPortfolioItemsCommand) => {
    return async (dispatch: any) => {
        dispatch(updateUserPortfolioRequestAction());

        const response = await useApi(() =>
            api.userPortfolioItems.userPortfolioItemsUpdate(command));

        if (response.result) {
            dispatch(updateUserPortfolioSuccessAction(response.result));
        }
        else {
            // TODO: error
            // dispatch(throwError(response.toString()));
        }
    };
};
